import { Avatar, Stack, Typography } from "@mui/material";
import { blue, deepPurple } from "@mui/material/colors";
import type { ThemeColorFn } from "@entrilia/shared/utilities/colorHelper";
import { makeModeAwareAccent, makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";
import SparklesIcon from "@entrilia/shared/icons/SparklesIcon";

interface Props {
  agentType: AgentType;
  avatarOnly?: boolean;
}

type AgentType = "task" | "validation" | "supervisor";

const iconColorMap: Record<AgentType, ThemeColorFn> = {
  task: (t) => t.palette.success.main,
  validation: (t) => makeModeAwareAccent(t, blue),
  supervisor: (t) => makeModeAwareAccent(t, deepPurple),
};

const titleMap: Record<AgentType, string> = {
  task: "Task Agent",
  validation: "Validation Agent",
  supervisor: "Supervisor Agent",
};

const WorkflowAgentLabel = ({ agentType, avatarOnly }: Props) => {
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <Avatar
        sx={(t) => ({
          width: 24,
          height: 24,
          bgcolor: makeTintedBackgroundFromColor(t, iconColorMap[agentType](t)),
        })}
      >
        <SparklesIcon sx={(t) => ({ width: 16, height: 16, color: iconColorMap[agentType](t) })} />
      </Avatar>
      {!avatarOnly && <Typography sx={{ width: "7.5rem" }}>{titleMap[agentType]}</Typography>}
    </Stack>
  );
};

export default WorkflowAgentLabel;
